import { Component, OnInit, ViewChild } from '@angular/core';
import { StatsService } from '../stats.service';
import {
  ApexChart,
  ApexAxisChartSeries,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
} from 'ng-apexcharts';


interface ApexXAxis {
  type?: 'category' | 'datetime' | 'numeric';
  categories?: any;
  labels?: {
    style?: {
      colors?: string | string[];
      fontSize?: string;
    };
  };
}

export interface ChartOptions {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  colors: string[];
  legend: ApexLegend;
}

@Component({
  selector: 'ngx-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss'],
})

export class StatsComponent implements OnInit {
  @ViewChild('chart', {static: true}) chart: ChartComponent;
  chartOptions: any;
  stats: any;
  categories = [['Casos', 'Confirmados'], 'Casos activos', 'Recuperados', 'Defunciones', 'Casos críticos'];

  constructor(
    private covidService: StatsService,
  ) {
    this.chartOptions = {
      series: [
        {
          name: 'distibuted',
          data: [],
        },
      ],
      chart: {
        height: 350,
        type: 'bar',
        events: {
          click(chart, w, e) {
            // console.log(chart, w, e)
          },
        },
      },
      colors: [
        '#008FFB',
        '#FEB019',
        '#00E396',
        '#FF4560',
        '#775DD0',
        '#546E7A',
        '#26a69a',
        '#D10CE8',
      ],
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      xaxis: {
        categories: this.categories,
        labels: {
          style: {
            colors: [
              '#008FFB',
              '#FEB019',
              '#00E396',
              '#FF4560',
              '#775DD0',
              '#546E7A',
              '#26a69a',
              '#D10CE8',
            ],
            fontSize: '12px',
          },
        },
      },
    };
  }

  ngOnInit() {
    this.getStats();
  }

  async getStats() {
    this.stats = await this.covidService.getStats();
    const data = [];
    data.push(this.stats.cases);
    data.push(this.stats.active);
    data.push(this.stats.recovered);
    data.push(this.stats.deaths);
    data.push(this.stats.critical);

    this.chartOptions.series = [{
      data,
    }];
  }
}
